export const LOADER_TRAINING_EVENTS         =       'LOADER_TRAINING_EVENTS';
export const GET_TRAINING_EVENTS            =       'GET_TRAINING_EVENTS';
export const TRAINING_EVENTS_FALLA          =       'TRAINING_EVENTS_FALLA';
export const SAVE_LOADER_TRAINING_EVENTS    =       'SAVE_LOADER_TRAINING_EVENTS';
export const FORM_TRAINING_EVENTS_FAIL      =       'FORM_TRAINING_EVENTS_FAIL';
export const LOADER_PERSON_RESPONSIBLE         =       'LOADER_PERSON_RESPONSIBLE';
export const GET_PERSON_RESPONSIBLE            =       'GET_PERSON_RESPONSIBLE';
